<template>
  <div>
    <LayoutHeader
      activeNav="数字艺术馆"
      :topColor="topColor"
      bannerType="header museum"
    />
    <div class="container">
      敬请期待
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
export default {
  data() {
    return {
      topColor: "",
    };
  },
  mounted() {
    this.initScroll();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //更改激活Nav
    changeActive(val) {
      this.activeNav = val;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 42px 0;
}
</style>